module.exports = __webpack_public_path__ + "static/media/linkedin.48a2133d.svg";